var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLink = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFF9E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4545 13C8.44255 13 6 15.4425 6 18.4545C6 21.4665 8.44255 23.9091 11.4545 23.9091H15.8182V21.7273H11.4545C9.64691 21.7273 8.18182 20.2622 8.18182 18.4545C8.18182 16.6469 9.64691 15.1818 11.4545 15.1818H15.8182V13H11.4545ZM20.1818 13V15.1818H24.5455C26.3531 15.1818 27.8182 16.6469 27.8182 18.4545C27.8182 20.2622 26.3531 21.7273 24.5455 21.7273H20.1818V23.9091H24.5455C27.5575 23.9091 30 21.4665 30 18.4545C30 15.4425 27.5575 13 24.5455 13H20.1818ZM12.5455 17.3636V19.5455H23.4545V17.3636H12.5455Z",
    fill: "#E9BC0E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.f955ee43.svg";
export { ForwardRef as ReactComponent };